module.exports = __webpack_public_path__ + "static/media/Dark Grey.a98257b5.jpg";